import React, { useMemo } from "react";
import { Trophy } from "lucide-react";
import { inr } from "../lib/format";

const NAMES = [
  "Rahul K.", "Vikram S.", "Amit P.", "Suresh M.", "Deepak R.", "Manoj T.",
  "Sanjay B.", "Ravi N.", "Kiran D.", "Arjun V.", "Prakash L.", "Nitin G.",
  "Harish C.", "Yogesh W.", "Dinesh J.", "Ajay H.", "Rakesh E.", "Sunil F.",
  "Ganesh O.", "Mahesh U.", "Pavan Q.", "Rohit Z.", "Imran A.", "Farhan X.",
  "Akash I.", "Vinay Y.", "Sameer K.", "Naveen R.", "Karthik M.", "Anil D.",
];

function mulberry32(a) {
  return function () {
    a |= 0; a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export const TodaysWinners = () => {
  const winners = useMemo(() => {
    const d = new Date();
    const seed = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
    const rand = mulberry32(seed);
    const pool = [...NAMES];
    const picked = [];
    for (let i = 0; i < 5; i++) {
      const idx = Math.floor(rand() * pool.length);
      const name = pool.splice(idx, 1)[0];
      const amount = Math.round((50000 + rand() * 450000) / 500) * 500;
      picked.push({ name, amount });
    }
    return picked.sort((a, b) => b.amount - a.amount);
  }, []);

  return (
    <div className="mt-6 rounded-2xl border border-border bg-card p-5" data-testid="todays-winners">
      <div className="flex items-center gap-2 mb-3">
        <Trophy className="h-4 w-4 text-yellow-400" />
        <h3 className="font-display font-semibold text-sm uppercase tracking-wider">Today's Winners</h3>
      </div>
      <div className="space-y-1.5">
        {winners.map((w, i) => (
          <div key={w.name} data-testid={`winner-row-${i}`}
            className="flex items-center justify-between rounded-xl bg-secondary/50 px-3 py-2">
            <div className="flex items-center gap-2.5">
              <span className={`grid place-items-center h-6 w-6 rounded-full text-[11px] font-extrabold ${
                i === 0 ? "text-black" : "bg-secondary text-muted-foreground"
              }`}
                style={i === 0 ? { background: "linear-gradient(135deg,#fde68a,#f59e0b 60%,#b45309)" } : undefined}>
                {i + 1}
              </span>
              <span className="text-sm font-semibold">{w.name}</span>
            </div>
            <span className={`font-display font-bold text-sm ${i === 0 ? "text-yellow-300" : "text-primary"}`}>
              +{inr(w.amount)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
